import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { AlbumDb } from '../redux/albumDbSlice';

const useOneAlbumDb = (albumId: string | undefined): AlbumDb | undefined => {
  const albumDb = useSelector((state: RootState) => state.albumDb);
  const album = albumId ? albumDb.albums[albumId] : undefined;

  return album;
}

export default useOneAlbumDb;
